var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ loading : _vm.isLoading},on:{"click":function($event){return _vm.action()}}},[_vm._t("default"),_c('spinner',{staticClass:"spinner"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }